import { Inject, Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { MySynchDataStore } from '../data-stores/mysynch.datastore';
@Pipe({
    standalone: false,
    name: 'demoUserFilter',
    pure:false
  })
  export class DemoUserFilter implements PipeTransform {


   private currentUser:any = {};

   constructor(@Inject(MySynchDataStore) protected mysynchDataStore: any){
    this.mysynchDataStore.currentUser
        .subscribe((user)=>{
        if(!_.isUndefined(user)){
            this.currentUser = user
            
        }
        });
   }

    transform(value: any, demoValue: any,override:boolean=false): any {
          if (!override && this.currentUser && _.get(this.currentUser,'IsDemoUser')) {
            return demoValue;
          }
          return value;

    }


  }